<template>
  <div class="filter-dropdown-component popout d-flex" tabindex="0">
    <button
      class="dropdown-button btn btn-outline-secondary d-flex align-items-center px-3"
    >
      <slot v-if="$slots['label']" name="label" />
      <template v-else>
        <span class="label me-2">
          {{ label }}
          <span v-if="filterCount > 0" class="ms-1 filter-count">
            {{ filterCount }}
          </span>
        </span>
        <IconChevronDown />
      </template>
    </button>
    <div class="popout-overlay">
      <button
        v-for="option in options"
        :key="option.id"
        class="item"
        @click="$emit('select', option)"
      >
        <slot name="option" :option="option" />
      </button>
    </div>
  </div>
</template>

<script>
import IconChevronDown from '../../../../templates/icons/chevron-down.svg';

export default {
  components: {
    IconChevronDown,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    filterCount: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
